const makePath = (path?: string): string => {
    if (path) {
        return `${path[0] !== '/' ? '/' : ''}${path}`
    }
    return ''
}

export interface IRouterPath {
    getHref: () => string
    getPath: (path?: string) => string
    getSubPath: (path?: string) => string
    substring: (from: number, length?: number) => string
    isPathPrefixMatch: (from: number, length?: number) => boolean
}

export class RouterPath implements IRouterPath {
    static create(routerPath: RouterPath | string, subPath?: string) {
        if (!routerPath && routerPath[0] !== '/') {
            throw new Error('fail')
        }
        let path = ''
        if (routerPath instanceof RouterPath) {
            path = routerPath.getPath()
        } else {
            path = routerPath
        }
        return new RouterPath(path, makePath(subPath))
    }

    constructor(
        private routerPath: string,
        private subPath: string,
    ) {
        /* empty */
    }

    /** 문자열 반환 */
    toString() {
        return this.getPath()
    }

    /** 전체 경로 */
    getHref(path = ''): string {
        return `${window.location.origin}${this.routerPath}${this.subPath}${makePath(path)}`
    }

    /** 절대 경로 */
    getPath(path = ''): string {
        return `${this.routerPath}${this.subPath}${makePath(path)}`
    }

    /** 상세주소 경로 */
    getSubPath(path = ''): string {
        return `${this.subPath}${makePath(path)}`
    }

    /** 필요한 경로만 추출 */
    substring(from: number, length?: number): string {
        if (length && from > length) {
            throw new Error('앞 숫자를 넘을수 없습니다.')
        }
        return this.getPath()
            .split('/')
            .reduce((acc, path, idx) => {
                if (path && from <= idx && (!length || idx < length)) {
                    return `${acc}/${path}`
                }
                return acc
            }, '')
    }

    /** 현재 경로가 일치하는지 여부 확인 */
    isPathPrefixMatch() {
        const pathname = window.location.pathname
        return pathname.startsWith(this.getPath())
    }

    toRegexPath(path = '') {
        return new RegExp(this.getPath(path), 'i')
    }
}
